import { render, staticRenderFns } from "./mainChain.vue?vue&type=template&id=5cfc458f&scoped=true&"
import script from "./mainChain.vue?vue&type=script&lang=js&"
export * from "./mainChain.vue?vue&type=script&lang=js&"
import style0 from "./mainChain.vue?vue&type=style&index=0&id=5cfc458f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc458f",
  null
  
)

export default component.exports